import { withViewModel } from '../../../../../../infrastructure/components/with-view-model';
import { EmailsTemplateFormPresentation } from './emails-template-form-presentation';
import { EmailsTemplateFormVM } from './emails-template-form.viewmodel';

interface IProps {
    vm: EmailsTemplateFormVM;
}

const EmailsTemplateFormContainer = withViewModel(
    EmailsTemplateFormPresentation,
    (props: IProps) => {
        return props.vm;
    },
    () => []
);

export { EmailsTemplateFormContainer as EmailsTemplateForm };
